import { PolicyValueType } from 'components/PolicyFilterDropdown';

interface DrillDownProps {
  policyId: PolicyValueType;
  criticality_in?: number[];
  hosts_in?: number[];
  status_in?: string[];
  cid?: number;
  search?: string;
  technology_id?: number;
  category?: string;
  modified_date_from?;
  modified_date_to?;
  age_min?;
  age_max?;
  closed_by_user?;
  // evaluation_date_from?;
  // evaluation_date_to?;
  // first_fail_date_from?;
  // first_fail_date_to?;
  // last_fail_date_from?;
  // last_fail_date_to?;
  // first_pass_date_from?;
  // first_pass_date_to?;
  // last_pass_date_from?;
  // last_pass_date_to?;
}

/**
 * NOTE: Should not be called directly, instead call getDrillDownUrl()
 * Internal Drill down function used for new vuln listing page
 * @param param0
 * @returns
 */
export function getDrillDownUrl({
  policyId,
  criticality_in,
  hosts_in,
  status_in,
  cid,
  search,
  technology_id,
  category,
  modified_date_from,
  modified_date_to,
  age_min = undefined,
  age_max = undefined,
  closed_by_user = undefined,
}: // evaluation_date_from,
// evaluation_date_to,
// first_fail_date_from,
// first_fail_date_to,
// last_fail_date_from,
// last_fail_date_to,
// first_pass_date_from,
// first_pass_date_to,
// last_pass_date_from,
// last_pass_date_to,
DrillDownProps) {
  let url = `pc-findings?`;
  if (policyId) url = `${url}policy_id=${policyId}`;
  if (cid) url = `${url}&control_id=${cid}`;
  if (technology_id) url = `${url}&technology_id=${technology_id}`;
  if (category) url = `${url}&category=${category}`;
  if (status_in && status_in.length > 0)
    url = `${url}&status=${status_in.join(',')}`;
  // default filter by passed and failed
  else url = `${url}&status=Passed,Failed`;
  if (criticality_in && criticality_in.length > 0)
    url = `${url}&criticality=${criticality_in.join(',')}`;
  if (hosts_in && hosts_in.length > 0)
    url = `${url}&host_ids=${hosts_in.join(',')}`;
  if (search) url = `${url}&search=${search}`;
  if (modified_date_from)
    url = `${url}&dt_filter__modified_date__from=${modified_date_from}`;
  if (modified_date_to)
    url = `${url}&dt_filter__modified_date__to=${modified_date_to}`;
  if (closed_by_user) url = `${url}&closed_by_user=${closed_by_user}`;
  if (age_min) url = `${url}&age__min_exclusive=${age_min}`;
  if (age_max) url = `${url}&age__max=${age_max}`;

  return url;
}
